import defaultTheme from './defaultTheme';
const belkTheme = Object.assign(Object.assign({}, defaultTheme), { link: '#23418e', button: Object.assign(Object.assign({}, defaultTheme.button), { text: '#23418e', background: '#23418e' }), chatIcon: Object.assign(Object.assign({}, defaultTheme.chatIcon), { background: '#23418e' }), radio: Object.assign(Object.assign({}, defaultTheme.radio), { inactiveBorder: '#23418e', border: '#23418e', background: '#23418e' }), field: {
        focus: '#23418e',
        label: '#23418e',
        icon: '#23418e',
    } });
export default belkTheme;
